var _defs, _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAutodeskIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: "100%",
    height: "100%",
    fill: "transparent"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 16 12)",
    id: "7a331eca-2044-41a6-8a67-dc579801afac"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1,
      visibility: "hidden"
    },
    vectorEffect: "non-scaling-stroke",
    x: -16,
    y: -12,
    rx: 0,
    ry: 0,
    width: 32,
    height: 24
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "1ef586d2-81c0-4756-a341-fbb5c39cb4ae"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.02 0 0 0.02 16 12)",
    id: "f0a64858-4c34-4ba0-8744-f251a9aa9065"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(0,0,0)",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-809, -554)",
    d: "M 987.5 -0.5 C 1186.5 -0.5 1385.5 -0.5 1584.5 -0.5 C 1603.5 3.16667 1614.83 14.5 1618.5 33.5 C 1618.5 391.833 1618.5 750.167 1618.5 1108.5 C 1411.83 1108.5 1205.17 1108.5 998.5 1108.5 C 998.856 1042.4 999.356 976.737 1000 911.5 C 1003.09 879.785 1017.59 854.952 1043.5 837 C 1206.83 739 1370.17 641 1533.5 543 C 1544.59 532.049 1546.43 519.549 1539 505.5 C 1534.16 498.66 1527.66 494.16 1519.5 492 C 1345.83 491.333 1172.17 491.333 998.5 492 C 668.327 697.363 338.327 902.863 8.5 1108.5 C 5.5 1108.5 2.5 1108.5 -0.5 1108.5 C -0.5 943.5 -0.5 778.5 -0.5 613.5 C 328.869 408.819 658.203 204.153 987.5 -0.5 Z",
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutodeskIcon);
export default __webpack_public_path__ + "static/media/autodesk-icon.c79dfdcd.svg";
export { ForwardRef as ReactComponent };